import { HRResourcesCtegoriesCreate } from "./hrResourcesCtegoriesCreate";
import { HRResourcesCtegoriesEdit } from "./hrResourcesCtegoriesEdit";
import { HRResourcesCtegoriesList } from "./hrResourcesCtegoriesList";

export default {
	create: HRResourcesCtegoriesCreate,
	edit: HRResourcesCtegoriesEdit,
	list: HRResourcesCtegoriesList,
};
